// Détecte le contexte "web app mobile admin" (PWA installée ou vue mobile).
// Le Session Timeout (inactivité) est volontairement désactivé dans ce contexte :
// la sécurité de l'appareil (verrouillage écran / biométrie) est jugée suffisante.
// La logique reflète exactement le rendu de AdminMobileApp (voir AdminDashboard.js).
export function isMobileAdminAppView() {
  if (typeof window === 'undefined') return false;
  try {
    const appview = new URLSearchParams(window.location.search).get('appview') === '1';
    return appview || window.innerWidth < 1024;
  } catch {
    return false;
  }
}

export default isMobileAdminAppView;

// Détecte le contexte "web app mobile ASSISTEUR" (PWA installée ou vrai téléphone).
// IMPORTANT : ne PAS se déclencher sur `appview=1` seul, car l'aperçu "format
// ordinateur" du dock admin passe aussi `appview=1` (pour masquer le dock imbriqué)
// et doit conserver la vue ORDINATEUR (sidebar). Le déclenchement mobile repose sur :
//  - le flag dédié `mobileapp=1` (aperçu mobile du dock), OU
//  - un vrai petit écran (< 1024) hors aperçu ordinateur.
export function isAssisteurMobileAppView() {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('mobileapp') === '1') return true;
    // Aperçu "format ordinateur" (appview=1 sans mobileapp) → rester en vue ordinateur.
    if (params.get('appview') === '1') return false;
    return window.innerWidth < 1024;
  } catch {
    return false;
  }
}
